import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    TabContent, TabPane, Nav,
    NavItem, NavLink, Row, Col
} from 'reactstrap';
import classnames from 'classnames';
import { TreeGridDemo } from './TreeGridDemo';
import { FilesFinder } from './FilesFinder';

export function ArchiveSearcher() {

    // State for current active Tab
    const [currentActiveTab, setCurrentActiveTab] = useState('1');

    // Toggle active state for Tab
    const toggle = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    return (
        <div style={{
            padding: 5
        }}>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({
                            active:
                                currentActiveTab === '1'                       
                        })}
                        style={{cursor: 'pointer' }}
                        onClick={() => { toggle('1'); }}
                    >
                        Search Files
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({
                            active:
                                currentActiveTab === '2'
                        })}
                        style={{ cursor: 'pointer' }}
                        onClick={() => { toggle('2'); }}
                    >
                        Search Archive Tree
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={currentActiveTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col sm="12">
                            {currentActiveTab === '1' && <FilesFinder />}                           
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row>
                        <Col sm="12">
                            {currentActiveTab === '2' && <TreeGridDemo />}
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>
        </div >
    );
}
